import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
    lang:"ca",
    showMenu: false,
    showSendAnswer: true,
    slide0Password:"-1",
    slide0Escola: "",
    slide0Equip: "",
    slide0Curs: "",
    solOptima: true,
    piecesGroup1:[
        {id:0, code: 12, name:"slide11-piece-12.png"},
        {id:1, code: 16, name:"slide11-piece-16.png"},
        {id:2, code: 22, name:"slide11-piece-22.png"},
        {id:3, code: 24, name:"slide11-piece-24.png"},
        {id:4, code: 25, name:"slide11-piece-25.png"},
        {id:5, code: 31, name:"slide11-piece-31.png"}   
    ],
    piecesGroup2:[
        {id:0, code: 13, name:"slide11-piece-13.png"},
        {id:1, code: 15, name:"slide11-piece-15.png"},
        {id:2, code: 21, name:"slide11-piece-21.png"},
        {id:3, code: 32, name:"slide11-piece-32.png"},
        {id:4, code: 34, name:"slide11-piece-34.png"},
        {id:5, code: 36, name:"slide11-piece-36.png"} 
    ],
    piecesGroup3:[
        {id:0, code: 11, name:"slide11-piece-11.png"},
        {id:1, code: 14, name:"slide11-piece-14.png"},
        {id:2, code: 23, name:"slide11-piece-23.png"},
        {id:3, code: 26, name:"slide11-piece-26.png"},
        {id:4, code: 33, name:"slide11-piece-33.png"},
        {id:5, code: 35, name:"slide11-piece-35.png"} 
    ],   
    slide11Piece1: "",
    slide11Piece2: "",
    slide11Piece3: "",
    slide11Piece1random:{},
    slide11Piece2random:{},
    slide11Piece3random:{},

    slide12Process1: "",
    slide12Process2: "",
    slide12Process3: "",

    slide13Machine1: "", 
    slide13Machine2: "", 
    slide13Machine3: "",
    slide13Machine4: "", 
    slide13Machine5: "", 
    slide13Machine6: "",
    
    
    slide14Conditioners1: null,
    slide14Conditioners2: null,
    slide14Conditioners3: "",

    slide23EndDesign1: null,
    slide23EndDesign2: null,
    slide23EndDesign3: null,
    slide23EndDesign4: null,
    slide23EndDesign5: null,
    slide23EndDesign6: "",
    slide23EndDesign7: "",
    slide23EndDesign8: "",
    slide23EndDesign9: "",

    PuntsJoc1: "",
    elapsedTimeGame1: "",
    PuntsJoc2: "",
    elapsedTimeGame2: "",
    puntsTotals: "0",

};

const getters = {
    getLang: state => {
        return state.lang;
    }
};

const mutations = {
    'SET_SHOWMENU' (state,value){
        state.showMenu=value;
    },    
    'UPDATE_VARIABLE' (state, payload){
        state[payload.name] = payload.value;
    },
    'CALCULATE_RANDOM_PIECES' (state) {        
        var index1 = Math.round(Math.random() * 5);
        var pieceGroup1=state.piecesGroup1.filter(function(elem){ 
            if(elem.id==index1){
                var result=[];
                result.push(elem.code);
                result.push(elem.name);
                return result;
            }
        });
        state.slide11Piece1random=pieceGroup1;

        var index2 = Math.round(Math.random() * 5);
        var pieceGroup2=state.piecesGroup2.filter(function(elem){ 
            if(elem.id==index2){
                var result=[];
                result.push(elem.code);
                result.push(elem.name);
                return result;
            }
        });
        state.slide11Piece2random=pieceGroup2;

        var index3 = Math.round(Math.random() * 5);
        var pieceGroup3=state.piecesGroup3.filter(function(elem){ 
            if(elem.id==index3){
                var result=[];
                result.push(elem.code);
                result.push(elem.name);
                return result;
            }
        });
        state.slide11Piece3random=pieceGroup3;
    }    
};

const actions = {
    changeShowMenu: ({commit}, value) => {
        commit('SET_SHOWMENU',value);
    },
    updateVariable: ({commit}, payload) => {
        commit('UPDATE_VARIABLE',{name:payload.name, value: payload.value});
    },
    calculateRandomPieces:({ commit }) => {
        commit('CALCULATE_RANDOM_PIECES');
    }
};

export const store = new Vuex.Store ({
    state,
    getters,
    mutations,
    actions
});